import { IconLoading } from '@/assets/icons/icon-loading'
import { Button } from '@/components/ui/button'

import ChatIcon from '../../../../../../icons/chat.svg'

interface Props {
  disabled?: boolean
  openChat?: () => void
  isOpenChatLoading?: boolean
}

export const OpenChat = ({ disabled, openChat, isOpenChatLoading }: Props) => {
  return (
    <Button
      variant="outline"
      className="border-primary-500 text-primary-500 hover:border-primary-500 hover:bg-primary-500 dark:border-primary-500 dark:text-primary-500 dark:hover:border-primary-500 dark:hover:bg-primary-500 block h-9 outline-none hover:text-white focus-visible:ring-0 dark:hover:text-white"
      onClick={openChat}
      disabled={isOpenChatLoading || disabled}
    >
      {isOpenChatLoading ? (
        <IconLoading className="m-0 animate-spin" />
      ) : (
        <ChatIcon />
      )}
    </Button>
  )
}
